import { Injectable } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";

@Injectable()
export class MatPaginatorIntlCustom extends MatPaginatorIntl {
  constructor() {
    super();
    this.itemsPerPageLabel = "Records per page:";
  }
}
